import { Plugin } from '@ckeditor/ckeditor5-core'
import TagsEditing from './tagsediting'
import TagsUI from './tagsui'

export default class Tags extends Plugin {
    static get requires() {
        return [TagsEditing, TagsUI]
    }
}